export default (() => {
    /* Set DOM elements */
    const bannerEl = document.querySelector('.js-banner-alert');
    const bannerClose = document.querySelector('.js-banner-close');
    const headerEl = document.querySelector('.header');
  
    if (bannerEl) {
        /* Get saved data from sessionStorage */
        const hideBannerAlert = sessionStorage.getItem('hideBannerAlert');
        
        /* Hide banner if the user clicked on close icon */
        if (hideBannerAlert) {
            bannerEl.classList.remove('is-active');
        } else {
            bannerEl.classList.add('is-active');
            document.body.classList.add('is-active');
        }

        if (headerEl) {
            /* Set header position to banner height */
            headerEl.style.top = `${bannerEl.offsetHeight}px`;
  
            /* Height check on window resize */
            window.addEventListener('resize', () => {
                headerEl.style.top = `${bannerEl.offsetHeight}px`;
            });
        }

        if (bannerClose) {
            /* Handle close */
            bannerClose.addEventListener('click', (event) => {
                event.preventDefault();
                closeBannerAlert();
            });
        }
    }

    const closeBannerAlert = () => {
        bannerEl.classList.remove('is-active');
        sessionStorage.setItem('hideBannerAlert', true);
        headerEl ? headerEl.style.top = 0 : null;
    };
})();